export const INITIALIZE = "INITIALIZE"
export const CHECK_PAYMENT_SETTING = "FETCH_PAYMENT_SETTING"
export const PURCHASE = "PURCHASE"
export const LOADING_MODAL = "LOADING_MODAL"
export const CONFIRMATION_MODAL = "CONFIRMATION_MODAL"
export const FINISH_MODAL = "FINISH_MODAL"
export const SHOW_PAYMENT_MODAL = "SHOW_PAYMENT_MODAL"
export const HIDE_PAYMENT_MODAL = "HIDE_PAYMENT_MODAL"
